// KORRIGIERT: Importpfad für i18n
import "./i18n/index"; // <-- HIER ANPASSEN
// Oder, wenn es ein direktes Importstatement ist, das das Modul initialisiert:
// import i18n from "./i18n/index"; // Wenn Sie es als Variable nutzen, sonst ist der obige ausreichend.

import React, { useContext } from "react";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import LoginForm from "./components/Login/LoginForm";
import MainTabs from "./components/Navigation/MainTabs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#000000",
    },
    background: {
      default: "rgb(184, 164, 116)",
      paper: "rgb(200, 180, 132)",
    },
    text: {
      primary: "#000000",
      secondary: "#333333",
    },
  },
  typography: {
    fontFamily: 'Verdana, Geneva, sans-serif',
    h4: {
      fontFamily: 'Verdana, Geneva, sans-serif',
      marginBottom: "24px",
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    h5: {
      fontFamily: 'Verdana, Geneva, sans-serif',
      marginBottom: "20px",
      fontWeight: 600,
    },
    h6: {
      fontFamily: 'Verdana, Geneva, sans-serif',
      marginBottom: "16px",
      fontWeight: 600,
    },
    body1: {
      fontFamily: 'Verdana, Geneva, sans-serif',
    },
    body2: {
      fontFamily: 'Verdana, Geneva, sans-serif',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(184, 164, 116)",
          color: "#000000",
          boxShadow: "none",
          borderBottom: "none",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#000000",
          fontFamily: 'Verdana, Geneva, sans-serif',
          textTransform: "none",
          fontWeight: 500,
          transition: "all 0.2s ease",
          borderRadius: "8px 8px 0 0",
          "&.Mui-selected": {
            color: "#000000",
            fontWeight: 600,
          },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#000000",
          height: "3px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Verdana, Geneva, sans-serif',
          borderRadius: "10px",
          textTransform: "none",
          fontWeight: 500,
          transition: "all 0.2s ease",
          "&.MuiButton-contained": {
            backgroundColor: "#000000",
            color: "#ffffff",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
            "&:hover": {
              backgroundColor: "#1a1a1a",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
              transform: "translateY(-1px)",
            },
            "&:active": {
              transform: "translateY(0)",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
            },
          },
          "&.MuiButton-outlined": {
            borderWidth: "1.5px",
            "&:hover": {
              borderWidth: "1.5px",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          backgroundColor: "rgb(200, 180, 132)",
          border: "none",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)",
          padding: "12px",
          transition: "box-shadow 0.3s ease, transform 0.2s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "rgb(200, 180, 132)",
            transition: "all 0.2s ease",
            "& fieldset": {
              border: "1.5px solid rgba(0, 0, 0, 0.2)",
              transition: "border-color 0.2s ease",
            },
            "&:hover fieldset": {
              border: "1.5px solid rgba(0, 0, 0, 0.35)",
            },
            "&.Mui-focused fieldset": {
              border: "2px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused": {
              boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.08)",
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          backgroundColor: "rgb(200, 180, 132)",
          transition: "all 0.2s ease",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1.5px solid rgba(0, 0, 0, 0.2)",
            transition: "border-color 0.2s ease",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "1.5px solid rgba(0, 0, 0, 0.35)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "2px solid rgba(0, 0, 0, 0.5)",
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.08)",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "rgb(200, 180, 132)",
            transition: "all 0.2s ease",
            "& fieldset": {
              border: "1.5px solid rgba(0, 0, 0, 0.2)",
              transition: "border-color 0.2s ease",
            },
            "&:hover fieldset": {
              border: "1.5px solid rgba(0, 0, 0, 0.35)",
            },
            "&.Mui-focused fieldset": {
              border: "2px solid rgba(0, 0, 0, 0.5)",
            },
            "&.Mui-focused": {
              boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.08)",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(200, 180, 132)",
          transition: "all 0.2s ease",
          "& fieldset": {
            border: "1.5px solid rgba(0, 0, 0, 0.2)",
            transition: "border-color 0.2s ease",
          },
          "&:hover fieldset": {
            border: "1.5px solid rgba(0, 0, 0, 0.35)",
          },
          "&.Mui-focused fieldset": {
            border: "2px solid rgba(0, 0, 0, 0.5)",
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.08)",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "16px",
          backgroundColor: "rgb(200, 180, 132)",
          border: "none",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1)",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          backgroundColor: "rgb(210, 190, 142)",
          transition: "background-color 0.2s ease",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          margin: "2px 4px",
          backgroundColor: "rgb(200, 180, 132)",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "rgb(210, 190, 142)",
            transform: "translateX(2px)",
          },
          "&.Mui-selected": {
            backgroundColor: "rgb(210, 190, 142)",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "rgb(210, 190, 142)",
            },
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          margin: "2px 0",
          backgroundColor: "transparent",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "rgb(210, 190, 142)",
            transform: "translateX(4px)",
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          margin: "2px 0",
          backgroundColor: "transparent",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "rgb(210, 190, 142)",
            transform: "translateX(4px)",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#000000",
          },
        },
      },
    },
  },
});

const globalStyles = (
  <GlobalStyles
    styles={{
      body: {
        backgroundColor: "rgb(184, 164, 116)",
        fontFamily: 'Verdana, Geneva, sans-serif',
        margin: 0,
        padding: 0,
      },
      "::-webkit-scrollbar": {
        width: "0px",
        height: "0px",
        background: "black",
      },
      "*": {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      },
    }}
  />
);

const AppContent: React.FC = () => {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <LoginForm />;
  }

  return <MainTabs />;
};

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {globalStyles}
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </ThemeProvider>
);

export default App;